import type { ComponentChildren } from 'preact';
import { ru } from '../../i18n/ru';
import { Button } from '../components/Button';
import { Dialog } from '../components/Dialog';
import './InstallGuideDialog.css';

/**
 * Safari's own symbols, so a kid can match them with what is on the screen: «Поделиться»
 * (a square with an arrow up), «На экран „Домой“» (a square with a plus), then «Добавить».
 */
const STEP_ICONS: ReadonlyArray<ComponentChildren> = [
  <SafariSymbol key="share">
    <path d="M8.5 9.5H7a1.5 1.5 0 0 0-1.5 1.5v8A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 17 9.5h-1.5" />
    <path d="M12 14.5V3.5M8.5 7 12 3.5 15.5 7" />
  </SafariSymbol>,
  <SafariSymbol key="add">
    <rect x="4.5" y="4.5" width="15" height="15" rx="3.5" />
    <path d="M12 8.5v7M8.5 12h7" />
  </SafariSymbol>,
  '✅',
];

/** iOS has no install prompt: explain "Share → Add to Home Screen" in three steps. */
export function InstallGuideDialog({ onClose }: { onClose(): void }) {
  return (
    <Dialog title={ru.install.guideTitle} onClose={onClose}>
      <ol class="install-guide">
        {ru.install.guideSteps.map((step, index) => (
          <li key={step} class="install-guide__step">
            <span class="install-guide__icon" aria-hidden="true">
              {STEP_ICONS[index]}
            </span>
            <span>{step}</span>
          </li>
        ))}
      </ol>
      <p class="install-guide__note">{ru.install.guideNote}</p>
      <Button variant="green" block onClick={onClose}>
        {ru.common.done}
      </Button>
    </Dialog>
  );
}

/** A Safari toolbar symbol: blue lines on a white tile, like the real button. */
function SafariSymbol({ children }: { children: ComponentChildren }) {
  return (
    <svg
      class="install-guide__symbol"
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      {children}
    </svg>
  );
}
